import { useRef } from "react";
import { connect } from "react-redux";
import { LogoImageReplaceIcon } from "../../../assets/icons/iconsProvider";
import LogoImage from "../../../assets/images/Rectangle31.png";
import { inventoryConstants, storeConstants } from "../../../constants";
import { inventoryActions } from "../../../redux/actions";
import { isSpinnerEnabled } from "../../utility";
import LoadingSpinnerIcon from "../LoaderSpinner/LoadingSpinnerIcon";

const InputImageField = (props) => {
  const {
    imgUrl,
    spinnerArray,
    setImgUrl = () => {},
    uploadProductImage,
  } = props;
  const hiddenFileInput = useRef(null);

  //-------Change Logo image button
  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };
  const handleImageChange = (e) => {
    uploadProductImage(
      e,
      {},
      (data) => {
        setImgUrl(data.imgUrl);
      },
      {
        isResize: true,
        newWidth: storeConstants.RECEIPT_IMAGE_RESIZE_WIDTH,
      }
    );
  };

  return (
    <div className="receipt-logo-image-wrapper">
      <img
        src={imgUrl || LogoImage}
        alt="logo"
        className="receipt-logo-image"
      />
      <input
        type="file"
        className="d-none"
        accept=".png, .jpg, .jpeg"
        onChange={handleImageChange}
        ref={hiddenFileInput}
      />
      <button
        onClick={handleReplaceButtonClick}
        type="button"
        className="replace-logo-button"
      >
        {isSpinnerEnabled(spinnerArray, inventoryConstants.UPLOAD_IMAGE) ? (
          <LoadingSpinnerIcon color="white" isApplyMargin={false} />
        ) : (
          <LogoImageReplaceIcon className="replace-icon" />
        )}
      </button>
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  uploadProductImage: (e, productDataObject, setProductDataObject, resize) =>
    dispatch(
      inventoryActions.uploadProductImage(
        e,
        productDataObject,
        setProductDataObject,
        resize
      )
    ),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(InputImageField);
